/* This example requires Tailwind CSS v2.0+ */
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Hero from "components/organisms/common/Hero"
import useTranslations from "hooks/useTranslations"

const HeroImage = ({ className }) => {
  const data = useStaticQuery(graphql`
    {
      hero: file(relativePath: { eq: "pro/hero.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 90)
        }
      }
    }
  `)

  return (
    <GatsbyImage
      loading="eager"
      image={getImage(data.hero)}
      className={className}
      imgStyle={{
        objectFit: "cover",
        objectPosition: "top",
      }}
    />
  )
}

export default function HeroMain() {
  const { hrTitle1, hrTitle2, hrTitle3, hrDescription, hrHighlight } =
    useTranslations()
  return (
    <Hero
      Image={HeroImage}
      slides={[hrTitle1, hrTitle2, hrTitle3]}
      searchWords={hrHighlight || [""]}
      description={hrDescription}
    />
  )
}
